export const NOTES_IDS_KEY = 'notesIds';
export const EVENTS_IDS_KEY = 'eventsIds';
